import * as ko from 'knockout';
import * as i18nextko from 'i18next-ko';

const i18nextTranslations: i18nextko.i18nextkoResourceStore = {
    en: {
        translation: {
            /* Offices map */
            map_viewongmaps: 'View on Google Maps',
            map_headquarters: 'Headquarters',
            map_phone: 'Phone',
            map_fax: 'Fax',
            map_other: 'Other',
            /* Forms */
            form_title: {
                event: 'Event registration'
            },
            form_subtitle: {
                ask_rose: 'We’re here to answer your questions and help you find solutions from across the Reply network.',
                rfp: 'Submit RFP'
            },
            form_privacyIntro: {
                unspecific: 'Before filling out the registration form, please read the ',
                supplier: 'Please fill in the registration form below with your personal information to explore collaboration possibilities with the Reply Group.'
            },
            form_privacyNotice: {
                unspecific: 'Privacy Notice',
                supplier: 'Supplier Privacy Notice'
            },
            form_article13: ' pursuant to Article 13 of EU Regulation 2016/679.',
            form_declare: {
                unspecific: 'I declare that I have read and fully understood the ',
                supplier: 'Reply is committed to protecting your personal data, which will be processed in accordance with all applicable data privacy laws. For further information, please read the Reply '
            },
            form_consent: {
                unspecific: ' and I hereby express my consent to the processing of my personal data by Reply SpA for marketing purposes, in particular to receive promotional and commercial communications or information regarding company events or webinars, using automated contact means (e.g. SMS, MMS, fax, email and web applications) or traditional methods (e.g. phone calls and paper mail).',
                supplier: '.'
            },
            form_getPaper: {
                unspecific: 'Get the paper using your '
            },
            form_credentialsROSE: {
                unspecific: 'ROSE credentials'
            },
            form_fillForm: {
                unspecific: ' or fill in the form below.'
            },
            form_doConsent: 'I consent',
            form_dontConsent: 'I do not consent',
            form_confirm: 'Confirm',
            form_name: 'Name__required__',
            form_surname: 'Surname__required__',
            form_email: {
                unspecific: 'Business Email__required__',
                ask_rose: 'Business email__required__',
                rfp: 'Business email__required__'
            },
            form_phone: 'Phone number',
            form_company: 'Company__required__',
            form_country: 'Country__required__',
            form_industry: 'Industry',
            form_product: 'What product are you interested in?',
            form_role: {
                unspecific: 'Job Role__required__',
                ask_rose: 'Job Role__required__',
                rfp: 'Job Role__required__',
            },
            form_message: {
                unspecific: 'Write your message__required__',
                supplier: 'Please introduce briefly yourself and your company__required__'
            },
            form_invalid: 'Something’s not right',
            form_apply: 'Apply',
            form_uploadFiles: 'Upload your file here',
            form_uploadFilesDescription: 'Please note that the total size of your attachment(s) must not exceed 100 MB. Appropriate attachment types are ".docx", ".pdf", and ".xlsx".',
            form_fileCta: 'Attach file',
            form_fileNoAttachment: 'No file attached',
            form_fileError: {
                tooBig: 'File too large',
                unspecific: 'Something went wrong with the attachment loading. Try again.',
                unsupported: 'Unsupported file format',
            },
            form_error: 'Something went wrong with the form submit. Try again.',
            form_additionalPrivacyIntro: 'I acknowledge that __company__ is a Reply business Partner and hereby express my consent to Reply sharing my personal data with __company__, who may use my data for marketing purposes as an independent Data Controller which I can contact to exercise my privacy rights. I have read and fully understand our ',
            form_additionalPrivacyNotice: 'Partner’s Privacy Notice',
            form_additionalPrivacyOutro: ' which includes with information about how __company__ processes my data and how I can contact them. I understand that Reply is not involved in the processing activities carried out by __company__.',
            success_title_overlay: 'Thank you for your interest',
            success_text_overlay_part1: 'In order to',
            success_text_overlay_part2: 'complete your request,',
            success_text_overlay_part3: 'please click the',
            success_text_overlay_part4: 'confirmation link',
            success_text_overlay_part5: 'in the email that we have sent to you.',
            confirmation_download: 'Your file',
            /* Office card */
            card_viewongmap: 'View on Google Maps',
            card_phone: 'Phone',
            card_fax: 'Fax',
            card_headquarters: 'Headquarters',
            card_discoverMore: 'Discover More',
            /* Others */
            card_download: 'Download', // unused
            wall_loadMore: 'Load more content',
            wall_search: 'Search',
            socialshare: 'Share with a friend',
            /* Search */
            search_title: 'What are you looking for?',
            search_placeholder: 'Type to search...',
            search_mostpopular: 'most popular searches',
            search_suggested: 'Suggested keywords',
            search_results: 'Showing results for',
            search_count_one: '1 result',
            search_count_other: '__count__ results',
            search_count_multiple: '__count__ of __total__ results',
            /* Careers */
            careers_searchLabel: 'What job are you looking for?',
            careers_search: 'Search now',
            table_toggletooltip: "Toggle tooltip",
            table_toggletable: "Toggle table",
            table_togglerow: "Toggle row",
            contact_phonenumber: "Phone number",
            contact_faxnumber: "Fax ",
            contact_email: "Mail to",
            map_showoffices: "Show Offices",
            map_hideoffices: "Hide Offices",
            pageindex_showpageindex: "Show page index",
            pageindex_hidepageindex: "Hide page index",
            serp_searchresults: "Search results",
            serp_clearsearchtext: "Clear search text",
            serp_previouspage: "Previous page",
            serp_nextpage: "Next page",
            accordion_toggle: "Toggle accordion",
            language_selector: "Language selector",
            close_language_selector: "Close language selector",
            close_menu_dropdown: "Close __name__",
            main_navigation: "Main navigation",
            go_to_homepage: "Go to homepage",
            menu_search: "Toggle search",
            mobile_menu_toggle: "Toggle menu",
            menu_highlighted_items: "Highlighted items",
            prev_slide: "Previous slide",
            next_slide: "Next slide",
            cookie_settings: "Open cookie settings",
            footer_navigation: "Footer navigation",
            go_to_reply: "Go to Reply website",
            search_filters: "Search filters",
        }
    },
    it: {
        translation: {
            /* Offices map */
            map_viewongmaps: 'Mostra su Google Maps',
            map_headquarters: 'Headquarter',
            map_phone: 'Telefono',
            map_fax: 'Fax',
            map_other: 'Altri',
            /* Forms */
            form_title: {
                event: 'Event registration'
            },
            form_subtitle: {
                ask_rose: 'Siamo pronti a rispondere alle tue domande e aiutarti a trovare le soluzioni di cui hai bisogno all’interno del network Reply.',
                rfp: 'Invia una RFP',
            },
            form_privacyIntro: {
                unspecific: 'Prima di compilare il form di registrazione, si prega di prendere visione dell\'',
                supplier: 'Presentaci il tuo business, la tua azienda o semplicemente te stesso ed esplora le possibilità di collaborazione all’interno del Gruppo Reply.',
            },
            form_privacyNotice: {
                unspecific: 'informativa Privacy',
                supplier: 'informativa Privacy Fornitori'
            },
            form_article13: ' ai sensi dell’art. 13 del Regolamento UE n° 679/2016.',
            form_declare: {
                unspecific: 'Dichiaro di aver letto e ben compreso l\'',
                supplier: 'Reply si impegna a proteggere i dati personali dell\'utente, che saranno trattati in conformità a qualsiasi legge sulla privacy applicabile. Per ulteriori informazioni si prega di leggere l\'',
            },
            form_consent: {
                unspecific: ' e acconsento al trattamento dei miei dati personali per finalità di marketing da parte di Reply SpA, in particolare per l’invio di comunicazioni promozionali e commerciali o la segnalazione di eventi aziendali o webinar, con modalità di contatto automatizzate (es. SMS, MMS, fax, e-mail e applicazioni web) e tradizionali (es. telefonate con operatore e posta tradizionale).',
                supplier: '.'
            },
            form_getPaper: {
                unspecific: 'Scarica il paper tramite le tue '
            },
            form_credentialsROSE: {
                unspecific: 'credenziali ROSE'
            },
            form_fillForm: {
                unspecific: ' o compila il form sottostante.'
            },
            form_doConsent: 'Do il consenso',
            form_dontConsent: 'Nego il consenso',
            form_confirm: 'Conferma',
            form_name: 'Nome__required__',
            form_surname: 'Cognome__required__',
            form_email: {
                unspecific: 'Business Email__required__',
                ask_rose: 'Business email__required__',
                rfp: 'Business email__required__'
            },
            form_phone: 'Telefono',
            form_company: 'Azienda__required__',
            form_country: 'Paese__required__',
            form_industry: 'Settore',
            form_product: 'A che prodotto sei interessato?',
            form_role: {
                unspecific: 'Ruolo__required__',
                ask_rose: 'Job Role__required__',
                rfp: 'Job Role__required__',
            },
            form_message: {
                unspecific: 'Inserisci qui il tuo messaggio__required__',
                supplier: 'Si prega di presentare brevemente se stessi o la propria azienda__required__'
            },
            form_invalid: 'Qualcosa non è andato a buon fine',
            form_apply: 'Applica',
            form_uploadFiles: 'Carica qui il tuo file',
            form_uploadFilesDescription: 'Nota: la dimensione totale dell’allegato o degli allegati non deve essere superiore a 10 Mb. Si accettano allegati con estensione “.doc”, “.pdf” e “.xlsx”.',
            form_fileCta: 'Allega file',
            form_fileNoAttachment: 'Nessun file selezionato',
            form_fileError: {
                tooBig: 'File troppo pesante',
                unspecific: 'Si è verificato un errore nel caricamento dell\'allegato. Si prega di riprovare.',
                unsupported: 'File non supportato',
            },
            form_error: 'Si è verificato un errore nell\'invio del form. Si prega di riprovare.',
            form_additionalPrivacyIntro: 'Dichiaro di essere informato che __company__ è un partner commerciale di Reply ed esprimo il mio consenso a Reply a condividere i miei dati personali con __company__, che può utilizzarli per scopi di marketing in qualità di titolare indipendente dei dati e che posso contattare per esercitare i miei diritti sulla privacy. Ho letto e compreso appieno l\'',
            form_additionalPrivacyNotice: 'informativa sulla privacy',
            form_additionalPrivacyOutro: ' di __company__, su come tratta i miei dati e su come posso contattarlo. Ho compreso che Reply non è coinvolta nelle attività di trattamento dei dati svolte da __company__.',
            success_title_overlay: 'Grazie per l’interesse dimostrato',
            success_text_overlay_part1: 'Per',
            success_text_overlay_part2: 'completare la richiesta,',
            success_text_overlay_part3: 'si prega di cliccare sul',
            success_text_overlay_part4: 'link di conferma',
            success_text_overlay_part5: 'che Le abbiamo inviato tramite e-mail.',
            confirmation_download: 'Il documento',
            /* Office card */
            card_viewongmap: 'Mostra su Google Maps',
            card_phone: 'Telefono',
            card_fax: 'Fax',
            card_headquarters: 'Headquarter',
            card_discoverMore: 'Scopri di più',
            /* Others */
            card_download: 'Scarica', // unused
            wall_loadMore: 'Mostra più contenuti',
            wall_search: 'Cerca',
            socialshare: 'Share with a friend',
            /* Search */
            search_title: 'Cosa stai cercando?',
            search_placeholder: 'Digita per cercare...', 
            search_mostpopular: 'Ricerche più frequenti', 
            search_suggested: 'Keyword suggerite',
            search_results: 'Showing results for',
            search_count_one: '1 result',
            search_count_other: '__count__ results',
            search_count_multiple: '__count__ of __total__ results',
            /* Careers */
            careers_searchLabel: 'Trova il tuo posto nel Gruppo Reply:',
            careers_search: 'Cerca',
            table_toggletooltip: "Toggle tooltip",
            table_toggletable: "Toggle table",
            table_togglerow: "Toggle row",
            contact_phonenumber: "Numero di telefono",
            contact_faxnumber: "Fax ",
            contact_email: "Mail to",
            map_showoffices: "Mostra uffici",
            map_hideoffices: "Nascondi uffici",
            pageindex_showpageindex: "Mostra indice pagina",
            pageindex_hidepageindex: "Nascondi indice pagina",
            serp_searchresults: "Effettua ricerca",
            serp_clearsearchtext: "Cancella testo ricerca",
            serp_previouspage: "Pagina precedente",
            serp_nextpage: "Pagina successiva",
            search_filters: "Search filters",
            accordion_toggle: "Toggle accordion"
        }
    },
    de: {
        translation: {
            /* Offices map */
            map_viewongmaps: 'Auf Google Maps anzeigen',
            map_headquarters: 'Hauptsitz',
            map_phone: 'Telefon',
            map_fax: 'Fax',
            map_other: 'Other',
            /* Forms */
            form_title: {
                event: 'Event registration'
            },
            form_subtitle: {
                ask_rose: 'Wir beantworten Ihre Fragen und helfen Ihnen, im Reply-Netzwerk die passenden Lösungen zu finden.',
                rfp: 'Ausschreibung senden',
            },
            form_privacyIntro: {
                unspecific: 'Bevor Sie das Anmeldeformular ausfüllen, lesen Sie bitte die ',
                supplier: 'Bitte geben Sie Ihre personenbezogenen Daten in das nachstehende Anmeldeformular ein, um Informationen für eine Zusammenarbeit mit der Reply-Gruppe zu erhalten.',
            },
            form_privacyNotice: {
                unspecific: 'Datenschutzerklärung',
                supplier: 'Supplier Privacy Notice'
            },
            form_article13: ' gemäß Artikel 13 der EU-Verordnung 2016/679.',
            form_declare: {
                unspecific: 'Ich erkläre, dass ich die ',
                supplier: 'Reply schützt und verarbeitet Ihre persönlichen Daten in Übereinstimmung mit den geltenden Datenschutzgesetzen. Weitere Informationen entnehmen Sie bitte der Reply Website ',
            },
            form_consent: {
                unspecific: ' gelesen und verstanden habe und erkläre mich mit der Verarbeitung meiner persönlichen Daten durch Reply SpA für Marketingzwecke einverstanden, insbesondere für den Erhalt von Werbe- und kommerziellen Mitteilungen oder Informationen über Reply Veranstaltungen oder Webinare unter Verwendung automatisierter Kontaktmittel (z.B. SMS, MMS, Fax, E-Mail und Webanwendungen) oder herkömmlicher Methoden (z.B. Telefonanrufe und Briefe).',
                supplier: '.'
            },
            form_getPaper: {
                unspecific: 'Dokument mit '
            },
            form_credentialsROSE: {
                unspecific: 'ROSE-Zugangsdaten'
            },
            form_fillForm: {
                unspecific: ' anfordern oder unten stehendes Formular ausfüllen.'
            },
            form_doConsent: 'Ich stimme zu',
            form_dontConsent: 'Ich stimme nicht zu',
            form_confirm: 'Bestätigen',
            form_name: 'Vorname__required__',
            form_surname: 'Nachname__required__',
            form_email: {
                unspecific: 'Geschäftliche E-Mail__required__',
                ask_rose: 'Geschäftliche E-Mail__required__',
                rfp: 'Geschäftliche E-Mail__required__'
            },
            form_phone: 'Telefon',
            form_company: 'Firma__required__',
            form_country: 'Land__required__',
            form_industry: 'Industrie',
            form_product: 'Für welches Produkt interessieren Sie sich?',
            form_role: {
                unspecific: 'Funktion__required__',
                ask_rose: 'Funktion__required__',
                rfp: 'Funktion__required__',
            },
            form_message: {
                unspecific: 'Hier Ihre Nachricht eingeben__required__',
                supplier: 'Bitte stellen Sie sich und Ihr Unternehmen kurz vor__required__'
            },
            form_invalid: 'Es ist ein Fehler aufgetreten',
            form_apply: 'Anwenden',
            form_uploadFiles: 'Laden Sie hier Ihre Datei hoch',
            form_uploadFilesDescription: 'Bitte beachten Sie, dass die Gesamtgröße Ihrer Anhänge 10 MB nicht überschreiten darf. Zulässige Dateitypen sind „.docx“, „.pdf“, und „.xlsx“.',
            form_fileCta: 'Datei anhängen',
            form_fileNoAttachment: 'Keine Datei ausgewählt',
            form_fileError: {
                tooBig: 'Datei zu groß',
                unspecific: 'Beim Laden des Anhangs ist ein Fehler aufgetreten. Bitte erneut versuchen.',
                unsupported: 'Dateiformat wird nicht unterstützt',
            },
            form_error: 'Something went wrong with the form submit. Try again.',
            form_additionalPrivacyIntro: 'Ich erkläre, dass ich darüber informiert wurde, dass __company__ ein Geschäftspartner von Reply ist und ich damit einverstanden bin, dass Reply meine persönlichen Daten an __company__ weitergibt. Ich erkläre darüber hinaus, dass __company__ meine Daten für Marketingzwecke verwenden darf als unabhängiger Datenverantwortlicher, an den ich mich wenden kann, um meine Datenschutzrechte auszuüben. Ich habe den ',
            form_additionalPrivacyNotice: 'Datenschutzhinweis',
            form_additionalPrivacyOutro: ' unseres Partners gelesen und vollständig verstanden, der auch Informationen darüber enthält, wie __company__ meine Daten verarbeitet und wie ich mich mit ihm in Verbindung setzen kann. Ich habe zur Kenntnis genommen, dass Reply nicht an den von __company__ durchgeführten Verarbeitungsaktivitäten beteiligt ist.',
            success_title_overlay: 'Vielen Dank für Ihr Interesse',
            success_text_overlay: 'Um Ihre Anfrage bearbeiten zu können, bitten wir Sie, auf den Bestätigungslink in der E-Mail zu klicken, die wir Ihnen soeben gesendet haben.', // to be split
            success_text_overlay_part1: 'Um Ihre Anfrage',
            success_text_overlay_part2: 'bearbeiten zu können,',
            success_text_overlay_part3: 'bitten wir Sie, auf den Bestätigungslink',
            success_text_overlay_part4: 'in der E-Mail zu klicken,',
            success_text_overlay_part5: 'die wir Ihnen soeben gesendet haben.',
            confirmation_download: 'Ihre Datei',
            /* Office card */
            card_viewongmap: 'Auf Google Maps anzeigen',
            card_phone: 'Telefon',
            card_fax: 'Fax',
            card_headquarters: 'Hauptsitz',
            card_discoverMore: 'Mehr erfahren',
            /* Others */
            card_download: 'Herunterladen', // unused
            wall_loadMore: 'Mehr Inhalte laden',
            wall_search: 'Search',
            socialshare: 'Share with a friend',
            /* Search */
            search_title: 'Wonach suchen Sie?',
            search_placeholder: 'Tippen, um zu suchen...', 
            search_mostpopular: 'Beliebteste Suchanfragen', 
            search_suggested: 'Vorgeschlagene Schlüsselwörter',
            search_results: 'Showing results for',
            search_count_one: '1 result',
            search_count_other: '__count__ results',
            search_count_multiple: '__count__ of __total__ results',
            /* Careers */
            careers_searchLabel: 'Finde deinen Job:',
            careers_search: 'Suche starten',
            table_toggletooltip: "Toggle tooltip",
            table_toggletable: "Toggle table",
            table_togglerow: "Toggle row",
            contact_phonenumber: "Telefonnummer",
            contact_faxnumber: "Fax ",
            contact_email: "Mail to",
            map_showoffices: "Büros anzeigen",
            map_hideoffices: "Büros ausblenden",
            pageindex_showpageindex: "Seitenindex anzeigen",
            pageindex_hidepageindex: "Seitenindex ausblenden",
            serp_searchresults: "Suchergebnisse",
            serp_clearsearchtext: "Suchtext löschen",
            serp_previouspage: "Vorherige Seite",
            serp_nextpage: "Nächste Seite",
            search_filters: "Search filters",
            accordion_toggle: "Toggle accordion"
        }
    },
    pt: {
        translation: {
            /* Offices map */
            map_viewongmaps: 'Ver no Google Maps',
            map_headquarters: 'Sede',
            map_phone: 'Telefone',
            map_fax: 'Fax',
            map_other: 'Outros',
            /* Forms */
            form_title: {
                event: 'Event registration'
            },
            form_subtitle: {
                ask_rose: 'Estamos aqui para responder às suas perguntas e ajudá-lo a encontrar soluções em toda a rede da Reply.',
                rfp: 'Enviar RFP',
            },
            form_privacyIntro: {
                unspecific: 'Antes de preencher o cadastro, por favor, leia o ',
                supplier: 'Por favor preencha o formulário abaixo com suas informações pessoais para explorar as possibilidades de colaboração dentro do Grupo Reply.',
            },
            form_privacyNotice: {
                unspecific: 'Política de Privacidade',
                supplier: 'Termo de Privacidade do Fornecedor',
            },
            form_article13: ', nos termos do art. 13 do Regulamento da UE n.º 679/2016',
            form_declare: {
                unspecific: 'Declaro que li a ',
                supplier: 'O Grupo Reply se compromete a proteger seus dados pessoais, os quais serão tratados em conformidade com as leis de privacidade de dados pertinentes. Para maiores informações, por favor leia o nosso ',
            },
            form_consent: {
                unspecific: ' e autorizo o processamento de meus dados pessoais para fins de marketing pela Reply SpA, em particular para o envio de comunicações promocionais e comerciais ou para o informar sobre eventos corporativos ou webinars, com métodos de contato automatizados (ex.: SMS, MMS, fax, e-mail e aplicativos web) e tradicionais (Ex.: telefonemas com operadora e correio tradicional).',
                supplier: '.'
            },
            form_getPaper: {
                unspecific: 'Obtenha o documento usando suas '
            },
            form_credentialsROSE: {
                unspecific: 'credenciais ROSE'
            },
            form_fillForm: {
                unspecific: ' ou preencha o formulário abaixo.'
            },
            form_doConsent: 'Eu autorizo',
            form_dontConsent: 'Eu não autorizo',
            form_confirm: 'Confirmar',
            form_name: 'Nome__required__',
            form_surname: 'Sombrenome__required__',
            form_email: {
                unspecific: 'E-mail__required__',
                ask_rose: 'E-mail profissional__required__',
                rfp: 'E-mail profissional__required__'
            },
            form_phone: 'Telefone',
            form_company: 'Nome de Empresa__required__',
            form_country: 'País__required__',
            form_industry: 'Indústria',
            form_product: 'Em que produto está interessado?',
            form_role: {
                unspecific: 'Cargo__required__',
                ask_rose: 'Cargo__required__',
                rfp: 'Cargo__required__',
            },
            form_message: {
                unspecific: 'Escreva sua mensagem__required__',
                supplier: 'Por favor faça uma breve apresentação sua ou da sua empresa__required__'
            },
            form_invalid: 'Algo não está certo',
            form_apply: 'Aplicar',
            form_uploadFiles: 'Faça upload de seu arquivo aqui',
            form_uploadFilesDescription: 'Observe que o tamanho total do(s) seu(s) anexo(s) não deve exceder 10 Mb. Os tipos de anexos suportados são “.doc”, “.pdf” e “.xlsx”.',
            form_fileCta: 'Anexar arquivo',
            form_fileNoAttachment: 'Nenhum arquivo selecionado',
            form_fileError: {
                tooBig: 'Ficheiro demasiado grande',
                unspecific: 'Algo correu mal com o carregamento do anexo. Tente novamente.',
                unsupported: 'Ficheiro não suportado',
            },
            form_error: 'Something went wrong with the form submit. Try again.',
            form_additionalPrivacyIntro: 'Declaro estar informado de que __company__ é um parceiro comercial da Reply e por meio deste expresso meu consentimento para que a Reply compartilhe meus dados pessoais com __company__, que poderá usar meus dados para fins de marketing, como controlador de dados independente, e que posso contatar para exercer meus direitos de privacidade. Li e compreendi completamente o ',
            form_additionalPrivacyNotice: 'Aviso de Privacidade',
            form_additionalPrivacyOutro: ' do nosso parceiro com informações também sobre como __company__ processa meus dados e como posso contatá-la. Compreendi que a Reply não está envolvida nas atividades de processamento realizadas pela __company__.',
            success_title_overlay: 'Obrigado pelo seu interesse',
            success_text_overlay: 'Para concluir a sua solicitação, pedimos que você clique no link de confirmação que acabamos de enviar por e-mail.', // to be split
            success_text_overlay_part1: 'Para concluir',
            success_text_overlay_part2: 'a sua solicitação,',
            success_text_overlay_part3: 'pedimos que você clique no',
            success_text_overlay_part4: 'link de confirmação',
            success_text_overlay_part5: 'que acabamos de enviar por e-mail.',
            confirmation_download: 'Seu arquivo',
            /* Office card */
            card_viewongmap: 'Ver no Google Maps',
            card_phone: 'Telefone',
            card_fax: 'Fax',
            card_headquarters: 'Sede',
            card_discoverMore: 'Descubra mais',
            /* Others */
            card_download: 'Baixe', // unused
            wall_loadMore: 'Carregar mais',
            wall_search: 'Search',
            socialshare: 'Share with a friend',
            /* Search */
            search_title: 'O que está procurando?',
            search_placeholder: 'Digite para pesquisar...', 
            search_mostpopular: 'Pesquisas_mais populares', 
            search_suggested: 'Palavras-chave sugeridas',
            search_results: 'Showing results for',
            search_count_one: '1 result',
            search_count_other: '__count__ results',
            search_count_multiple: '__count__ of __total__ results',
            /* Careers */
            careers_searchLabel: 'Encontre a sua oportunidade:',
            careers_search: 'Procure agora',
            table_toggletooltip: "Toggle tooltip",
            table_toggletable: "Toggle table",
            table_togglerow: "Toggle row",
            contact_phonenumber: "Telefone",
            contact_faxnumber: "Fax",
            contact_email: "Mail to",
            map_showoffices: "Mostrar escritórios",
            map_hideoffices: "Ocultar escritórios",
            pageindex_showpageindex: "Mostrar índice de páginas",
            pageindex_hidepageindex: "Ocultar índice de páginas",
            serp_searchresults: "Resultados da busca",
            serp_clearsearchtext: "Limpar texto da busca",
            serp_previouspage: "Página anterior",
            serp_nextpage: "Próxima página",
            search_filters: "Search filters",
            accordion_toggle: "Toggle accordion"
        }
    },
    fr: {
        translation: {
            /* Offices map */
            map_viewongmaps: 'Voir sur Google Maps',
            map_headquarters: 'Siège social',
            map_phone: 'Numéro de téléphone',
            map_fax: 'Fax',
            map_other: 'Autre',
            /* Forms */
            form_title: {
                event: 'Event registration'
            },
            form_subtitle: {
                ask_rose: 'Nous sommes là pour répondre à vos questions et vous aider à trouver des solutions à travers le réseau Reply.',
                rfp: 'Envoyer une demande de proposition',
            },
            form_privacyIntro: {
                unspecific: 'Avant de remplir le formulaire d\'inscription, veuillez lire le ',
                supplier: 'Veuillez remplir le formulaire d\'inscription ci-dessous avec vos informations personnelles afin d\'explorer les possibilités de collaboration au sein du Groupe Reply.',
            },
            form_privacyNotice: {
                unspecific: 'Privacy Notice',
                supplier: 'Supplier Privacy Notice'
            },
            form_article13: ' conformément à l\'article 13 du règlement UE 2016/679.',
            form_declare: {
                unspecific: 'Je déclare avoir lu et pleinement compris la note d\'information sur la protection des données personnelles ',
                supplier: 'Reply s\'engage à protéger vos données personnelles qui seront traitées conformément à toute loi applicable en matière de confidentialité des données. Pour plus d\'informations, veuillez lire le document Reply ',
            },
            form_consent: {
                unspecific: ' et j\'exprime par la présente mon consentement au traitement de mes données personnelles par Reply SpA à des fins de marketing, en particulier pour recevoir des communications promotionnelles et commerciales ou des informations concernant des événements ou des webinaires de l\'entreprise, en utilisant des moyens de contact automatisés (par exemple, SMS, MMS, fax, e-mail et applications web) ou des méthodes traditionnelles (par exemple, appels téléphoniques et courrier papier).',
                supplier: '.'
            },
            form_getPaper: {
                unspecific: 'Obtenez le document en utilisant vos '
            },
            form_credentialsROSE: {
                unspecific: 'ROSE credentials'
            },
            form_fillForm: {
                unspecific: ' ou en remplissant le formulaire ci-dessous.'
            },
            form_doConsent: 'J\'y consens',
            form_dontConsent: 'Je n\'y consens pas',
            form_confirm: 'Confirmer',
            form_name: 'Prénom__required__',
            form_surname: 'Nom__required__',
            form_email: {
                unspecific: 'E-mail professionnel __required__',
                ask_rose: 'E-mail professionnel __required__',
                rfp: 'E-mail professionnel __required__'
            },
            form_phone: 'Numéro de téléphone',
            form_company: 'Entreprise__required__',
            form_country: 'Pays__required__',
            form_industry: 'Secteur d’activité',
            form_product: 'Quel produit vous intéresse ?',
            form_role: {
                unspecific: 'Titre professionel__required__',
                ask_rose: 'Titre professionel__required__',
                rfp: 'Titre professionel__required__',
            },
            form_message: {
                unspecific: 'Rédigez votre message__required__',
                supplier: 'Veuillez vous présenter brièvement, ainsi que votre entreprise__required__'
            },
            form_invalid: 'Quelque chose ne va pas',
            form_apply: 'Envoyer',
            form_uploadFiles: 'Téléchargez votre dossier ici',
            form_uploadFilesDescription: 'Veuillez noter que la taille totale de vos pièces jointes ne peut pas dépasser 10 Mo. Les formats de pièces jointes acceptés sont “.doc”, “.pdf” et “.xlsx”.',
            form_fileCta: 'Joindre un fichier',
            form_fileNoAttachment: 'Aucun fichier sélectionné',
            form_fileError: {
                tooBig: 'Fichier trop volumineux',
                unspecific: 'Un problème est survenu lors du chargement de la pièce jointe. Essayez à nouveau.',
                unsupported: 'Fichier non pris en charge',
            },
            form_error: 'Something went wrong with the form submit. Try again.',
            form_additionalPrivacyIntro: 'Je déclare avoir pris connaissance que __company__ est un partenaire commercial de Reply, et, par la présente, je donne mon consentement explicite à ce que Reply partage mes données personnelles avec __company__ à des fins de marketing en tant que contrôleur de données indépendant que je peux contacter pour exercer mes droits à la vie privée. Je déclare avoir lu, compris et approuvé pleinement la ',
            form_additionalPrivacyNotice: 'politique de confidentialité',
            form_additionalPrivacyOutro: ' de notre partenaire avec des informations également sur la façon dont __company__ traite mes données et comment je peux les contacter. Je déclare avoir pris connaissance du fait que Reply n\'est pas impliqué dans les activités de traitement effectuées par __company__.',
            success_title_overlay: 'Merci de l’intérêt que vous nous portez',
            success_text_overlay: 'Afin de nous permettre de traiter votre demande, nous vous prions de bien vouloir cliquer sur le lien de confirmation que nous vous avons envoyé par e-mail.',
            success_text_overlay_part1: 'Afin de nous permettre',
            success_text_overlay_part2: 'de traiter votre demande,',
            success_text_overlay_part3: 'nous vous prions de bien vouloir',
            success_text_overlay_part4: 'cliquer sur le lien de confirmation',
            success_text_overlay_part5: 'que nous vous avons envoyé par e-mail.',
            confirmation_download: 'Votre fichier',
            /* Office card */
            card_viewongmap: 'Voir sur Google Maps',
            card_phone: 'Numéro de téléphone',
            card_fax: 'Fax',
            card_headquarters: 'Siège social',
            card_discoverMore: 'En savoir plus'
            /* Others */,
            card_download: 'Télécharger', // unused
            wall_loadMore: 'Charger plus',
            wall_search: 'Search',
            socialshare: 'Share with a friend',
            /* Search */
            search_title : 'Que cherchez-vous ?',
            search_placeholder : 'Tapez pour rechercher',
            search_mostpopular : 'Recherches les plus populaires',
            search_suggested: 'Mots-clés suggérés',
            search_results: 'Showing results for',
            search_count_one: '1 result',
            search_count_other: '__count__ results',
            search_count_multiple: '__count__ of __total__ results',
            /* Careers */
            careers_searchLabel: 'Quel emploi recherchez-vous?',
            careers_search: 'Rechercher maintenant',
            table_toggletooltip: "Toggle tooltip",
            table_toggletable: "Toggle table",
            table_togglerow: "Toggle row",
            contact_phonenumber: "Numéro de téléphone",
            contact_faxnumber: "Fax ",
            contact_email: "Mail to",
            map_showoffices: "Afficher les bureaux",
            map_hideoffices: "Masquer les bureaux",
            pageindex_showpageindex: "Afficher l'index de la page",
            pageindex_hidepageindex: "Masquer l'index de la page",
            serp_searchresults: "Résultats de recherche",
            serp_clearsearchtext: "Effacer le texte de recherche",
            serp_previouspage: "Page précédente",
            serp_nextpage: "Page suivante",
            search_filters: "Search filters",
            accordion_toggle: "Toggle accordion"
        }
    }
};

export function initi18n(): void {
    i18nextko.init(i18nextTranslations, 'en', ko);
}

export function seti18nLang(lang: string): void {
    i18nextko.setLanguage(lang);
}
